import axios from 'axios'
import { useCallback } from 'react'

import { PROPERTY_TYPES } from '../../common/drmTypes'
import { PropertyDataTypes } from '../../redux/fetchAction'
import { useAppSelector } from '../../redux/hooks'
import { requestPropertyDrmPath } from './paths'
import { useDispatchFetch } from './useDispatchFetch'

export const useFetchPropertyDrm = () => {
  const token = useAppSelector(state => state.myProfile.token)
  const { dispatchError, dispatchFetching, dispatchSuccess } =
    useDispatchFetch()

  const setError = useCallback(() => {
    dispatchError(PropertyDataTypes.DRM)
    //LV is directly dependent on the DRM response
    dispatchError(PropertyDataTypes.LV_GEOMETRY)
    dispatchError(PropertyDataTypes.LV)
  }, [dispatchError])

  const fetchDrm = useCallback(
    async (propertyId: string, propertyType?: PROPERTY_TYPES) => {
      if (!token || !propertyId || !propertyType) return setError()

      const requestPath = requestPropertyDrmPath(
        propertyType,
        token,
        propertyId
      )

      dispatchFetching(PropertyDataTypes.DRM)
      const response = await axios.get(requestPath)
      if (response.status !== 200) return setError()

      const data = await response.data
      dispatchSuccess(PropertyDataTypes.DRM, { ...data, type: propertyType })

      return {
        lv: data?.lv,
        cadastralCode: data?.katastralniUzemi?.kod,
      }
    },
    [dispatchFetching, dispatchSuccess, setError, token]
  )

  return fetchDrm
}
